import applicationIcon from "../../pictures/form.png";
import admissionIcon from "../../pictures/admission.png";
import usersIcon from "../../pictures/users.png";
import financeIcon from "../../pictures/finance.png";
import sun from "../../pictures/sun_2.png";
import moon from "../../pictures/half_moon.png";
import settingsIcon from "../../pictures/settings.png";
import dashboardIco from "../../pictures/dashboard.png";
import logo from "../../pictures/logo.png";

import {
  Sidebar,
  Menu,
  MenuItem,
  useProSidebar,
  SubMenu,
} from "react-pro-sidebar";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Avatar, Chip, Divider } from "@mui/material";
import {
  ADMIN_PAGE_ACCESS_OPTIONS,
  getStoredAdditionalPages,
} from "../../utils/access-control";

const ACCOUNT_OFFICER_ROLES = ["accounting", "account-officer"];
const pageLabels = ADMIN_PAGE_ACCESS_OPTIONS.flatMap((group) => group.pages).reduce(
  (labels, page) => ({
    ...labels,
    [page.path]: page.label,
  }),
  {}
);

const toAdminRelativePath = (path) => path.replace(/^\/admin\/?/, "");

const SideNavBar = () => {
  const { collapsed, toggleSidebar } = useProSidebar();
  const navigate = useNavigate();
  const userAccess = localStorage.getItem("access");
  const officeRole = localStorage.getItem("officeRole");
  const isAccountOfficer =
    userAccess === "accounting" ||
    (userAccess === "officer" && ACCOUNT_OFFICER_ROLES.includes(officeRole));
  const additionalPages = getStoredAdditionalPages();

  const handleAccess = (loc) => {
    toggleSidebar();
    navigate(loc);
  };

  const additionalMenuPages = additionalPages.filter(
    (path) => path !== "/admin/invoices-report"
  );

  const renderAdditionalPagesMenu = () =>
    additionalMenuPages.length > 0 && (
      <SubMenu
        icon={<BarIcons img={settingsIcon} />}
        label="Added Access"
        style={{ textAlign: "left" }}
      >
        {additionalMenuPages.map((path) => (
          <MenuItem
            key={path}
            style={{ textAlign: "left" }}
            onClick={() => {
              handleAccess(toAdminRelativePath(path));
            }}
          >
            {pageLabels[path] || path}
          </MenuItem>
        ))}
      </SubMenu>
    );

  if (isAccountOfficer) {
    return (
      <div style={{ display: "flex" }}>
        <Sidebar
          breakPoint="sm"
          transitionDuration={800}
          style={{ background: "#feffff" }}
        >
          <Menu>
            <div style={{ display: "flex" }}>
              <AppLogo />
            </div>

            <div className="mt-4">{!collapsed && <UserGreatings />}</div>

            <Divider className="my-1" />

            <MenuItem
              style={{ textAlign: "left" }}
              onClick={() => {
                handleAccess("invoices-report");
              }}
              icon={<BarIcons img={financeIcon} />}
            >
              Invoices Report
            </MenuItem>

            {renderAdditionalPagesMenu()}
          </Menu>
        </Sidebar>
      </div>
    );
  }

  return (
    <div style={{ display: "flex" }}>
      <Sidebar
        breakPoint="sm"
        transitionDuration={800}
        style={{ background: "#feffff" }}
      >
        <Menu>
          <div style={{ display: "flex" }}>
            <AppLogo />
          </div>

          <div className="mt-4">{!collapsed && <UserGreatings />}</div>

          <Divider className="my-1" />
          <MenuItem
            style={{ textAlign: "left" }}
            onClick={() => {
              handleAccess("");
            }}
            icon={<BarIcons img={dashboardIco} />}
          >
            DashBoard
          </MenuItem>
          <Divider className="my-1" />

          <SubMenu
            icon={<BarIcons img={applicationIcon} />}
            label="Application"
            style={{ textAlign: "left" }}
          >
            <MenuItem
              style={{ textAlign: "left" }}
              onClick={() => {
                handleAccess("application");
              }}
            >
              Set-up
            </MenuItem>
            <MenuItem
              style={{ textAlign: "left" }}
              onClick={() => {
                handleAccess("list-of-applicants");
              }}
            >
              List of Applicants
            </MenuItem>
            <MenuItem
              style={{ textAlign: "left" }}
              onClick={() => {
                handleAccess("academic-session-management");
              }}
            >
              Academic Session Management
            </MenuItem>
          </SubMenu>

          <SubMenu
            icon={<BarIcons img={admissionIcon} />}
            label="Admission"
            style={{ textAlign: "left" }}
          >
            <MenuItem
              style={{ textAlign: "left" }}
              onClick={() => {
                handleAccess("admission");
              }}
            >
              Admit Student
            </MenuItem>
            <MenuItem
              style={{ textAlign: "left" }}
              onClick={() => {
                handleAccess("list-of-admission");
              }}
            >
              Admitted Students
            </MenuItem>

            <MenuItem
              style={{ textAlign: "left" }}
              onClick={() => {
                handleAccess("list-of-registered");
              }}
            >
              Registered Students
            </MenuItem>

            <MenuItem
              style={{ textAlign: "left" }}
              onClick={() => {
                handleAccess("students-id-card");
              }}
            >
              Students ID Card
            </MenuItem>
          </SubMenu>

          <SubMenu
            label="Finance"
            style={{ textAlign: "left" }}
            icon={<BarIcons img={financeIcon} />}
          >
            <MenuItem
              style={{ textAlign: "left" }}
              onClick={() => {
                handleAccess("finance");
              }}
            >
              Manage Payment
            </MenuItem>
            <MenuItem
              style={{ textAlign: "left" }}
              onClick={() => {
                handleAccess("finance/settlement-creation");
              }}
            >
              Settlement Creation
            </MenuItem>
            <MenuItem
              style={{ textAlign: "left" }}
              onClick={() => {
                handleAccess("finance/settlements");
              }}
            >
              Settlement Management
            </MenuItem>
            <MenuItem
              style={{ textAlign: "left" }}
              onClick={() => {
                handleAccess("invoices-report");
              }}
            >
              Invoices Report
            </MenuItem>
            <MenuItem
              style={{ textAlign: "left" }}
              onClick={() => {
                handleAccess("invoice-sync");
              }}
            >
              Invoice Sync
            </MenuItem>
            <MenuItem
              style={{ textAlign: "left" }}
              onClick={() => {
                handleAccess("account-reconciliation");
              }}
            >
              Account Reconciliation
            </MenuItem>
            <MenuItem
              style={{ textAlign: "left" }}
              onClick={() => {
                handleAccess("hostel-reports");
              }}
            >
              Hostel Reports
            </MenuItem>
            <MenuItem
              style={{ textAlign: "left" }}
              onClick={() => {
                handleAccess("funds-transfer");
              }}
            >
              Funds Transfer
            </MenuItem>
            {/* <MenuItem
              style={{ textAlign: "left" }}
              onClick={() => {
                handleAccess("manual-payment");
              }}
            >
              Manual Payment
            </MenuItem> */}
            <MenuItem
              style={{ textAlign: "left" }}
              onClick={() => {
                handleAccess("create-invoice");
              }}
            >
              Create Invoice
            </MenuItem>

            <MenuItem
              style={{ textAlign: "left" }}
              onClick={() => {
                handleAccess("raised-invoices");
              }}
            >
              List of Invoices Raised
            </MenuItem>
          </SubMenu>

          <MenuItem
            style={{ textAlign: "left" }}
            onClick={() => {
              handleAccess("users");
            }}
            icon={<BarIcons img={usersIcon} />}
          >
            Users
          </MenuItem>

          <SubMenu
            icon={<BarIcons img={settingsIcon} />}
            label="Quality Assurance"
            style={{ textAlign: "left" }}
          >
            <MenuItem
              style={{ textAlign: "left" }}
              onClick={() => {
                handleAccess("undertaking-reports");
              }}
            >
              Reports of Undertakings
            </MenuItem>
            <MenuItem
              style={{ textAlign: "left" }}
              onClick={() => {
                handleAccess("student-finance-report");
              }}
            >
              Students Finance Report
            </MenuItem>
          </SubMenu>

          {renderAdditionalPagesMenu()}

          <SubMenu
            icon={<BarIcons img={usersIcon} />}
            label="Office"
            style={{ textAlign: "left" }}
          >
            {localStorage.getItem("officeRole") === "hod" && (
              <>
                <MenuItem
                  style={{ textAlign: "left" }}
                  onClick={() => {
                    handleAccess("dept-reports");
                  }}
                >
                  Dept Report
                </MenuItem>

                <MenuItem
                  style={{ textAlign: "left" }}
                  onClick={() => {
                    handleAccess("confirm-admission");
                  }}
                >
                  Student Admission
                </MenuItem>
                <MenuItem
                  style={{ textAlign: "left" }}
                  onClick={() => {
                    handleAccess("hod-clearance");
                  }}
                >
                  Clearance
                </MenuItem>

                <MenuItem
                  style={{ textAlign: "left" }}
                  onClick={() => {
                    handleAccess("course-management");
                  }}
                >
                  Course Management
                </MenuItem>

                <MenuItem
                  style={{ textAlign: "left" }}
                  onClick={() => {
                    handleAccess("hod");
                  }}
                >
                  Results
                </MenuItem>

                <MenuItem
                  style={{ textAlign: "left" }}
                  onClick={() => {
                    handleAccess("hod-undertakings");
                  }}
                >
                  Undertakings
                </MenuItem>
              </>
            )}
            {localStorage.getItem("officeRole") === "sao" && (
              <>
                <MenuItem
                  style={{ textAlign: "left" }}
                  onClick={() => {
                    handleAccess("sao");
                  }}
                >
                  Admission
                </MenuItem>
                <MenuItem
                  style={{ textAlign: "left" }}
                  onClick={() => {
                    handleAccess("sao-clearance");
                  }}
                >
                  Clearance
                </MenuItem>
                <MenuItem
                  style={{ textAlign: "left" }}
                  onClick={() => {
                    handleAccess("sao");
                  }}
                >
                  Reports
                </MenuItem>
              </>
            )}
            {localStorage.getItem("officeRole") === "registerer" && (
              <>
                <MenuItem
                  style={{ textAlign: "left" }}
                  onClick={() => {
                    handleAccess("scholarship");
                  }}
                >
                  Scholarship
                </MenuItem>
                <MenuItem
                  style={{ textAlign: "left" }}
                  onClick={() => {
                    handleAccess("registrar-clearance");
                  }}
                >
                  Registrar Clearance
                </MenuItem>
                <MenuItem
                  style={{ textAlign: "left" }}
                  onClick={() => {
                    handleAccess("registrar-stationaries");
                  }}
                >
                  Stationaries Registration
                </MenuItem>
                <MenuItem
                  style={{ textAlign: "left" }}
                  onClick={() => {
                    handleAccess("exit-card-list");
                  }}
                >
                  Exit Card List
                </MenuItem>
                <MenuItem
                  style={{ textAlign: "left" }}
                  onClick={() => {
                    handleAccess("hod");
                  }}
                >
                  Reports
                </MenuItem>
                <MenuItem
                  style={{ textAlign: "left" }}
                  onClick={() => {
                    handleAccess("registration-docs");
                  }}
                >
                  Registration Documents
                </MenuItem>
                <MenuItem
                  style={{ textAlign: "left" }}
                  onClick={() => {
                    handleAccess("registrar-admissions");
                  }}
                >
                  Admission Approvals
                </MenuItem>
                <MenuItem
                  style={{ textAlign: "left" }}
                  onClick={() => {
                    handleAccess("registrar-undertakings");
                  }}
                >
                  Undertakings
                </MenuItem>
              </>
            )}
            {["accounting", "finance", "bs", "account-officer"].includes(
              localStorage.getItem("officeRole") || ""
            ) && (
              <>
                <MenuItem
                  style={{ textAlign: "left" }}
                  onClick={() => {
                    handleAccess("account-clearance");
                  }}
                >
                  Accounts Clearance
                </MenuItem>
                <MenuItem
                  style={{ textAlign: "left" }}
                  onClick={() => {
                    handleAccess("stationary-collection");
                  }}
                >
                  Stationary Collection
                </MenuItem>
              </>
            )}
          </SubMenu>

          <MenuItem
            style={{ textAlign: "left" }}
            onClick={() => {
              handleAccess("settings");
            }}
            icon={<BarIcons img={settingsIcon} />}
          >
            Site Administration
          </MenuItem>
        </Menu>
      </Sidebar>
    </div>
  );
};

const AppLogo = () => {
  const navigate = useNavigate();
  const { collapseSidebar, collapsed } = useProSidebar();

  const toggle = () => {
    collapseSidebar();
  };

  return (
    <div>
      <div
        onClick={() => {
          navigate("/");
        }}
        className=" align-items-center"
        style={{ display: "flex", margin: "10px", justifyContent: "end" }}
      >
        <img
          style={{ cursor: "pointer", width: "50px", height: "50px" }}
          src={logo}
          alt="MCCHST logo"
        />

        {!collapsed && (
          <h3 className="m-2" style={{ fontSize: "22px", fontWeight: 900 }}>
            MCCHST FUNTUA
          </h3>
        )}
      </div>
    </div>
  );
};

const BarIcons = (props) => {
  return (
    <img
      className="circle"
      style={{ width: "48px", height: "48px", padding: "15px" }}
      src={props.img}
      alt=""
    />
  );
};

const UserGreatings = () => {
  const [greating, setGreating] = useState("");
  const [greatingIcon, setGreatingIcon] = useState(sun);

  useEffect(() => {
    const date = new Date();
    const formatter = new Intl.DateTimeFormat("en-US", {
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
      timeZone: "Africa/Lagos",
    });
    const time = formatter.format(date).split(" ")[1];
    const hour = formatter.format(date).split(" ")[0];
    const hourVal = parseInt(hour);

    let greeting = "";
    if (hourVal >= 5 && hourVal < 12 && time === "AM") {
      greeting = "Good Morning";
    } else if (
      (hourVal >= 1 && hourVal < 5 && time === "PM") ||
      hourVal === 12
    ) {
      greeting = "Good Afternoon";
      setGreatingIcon(moon);
    } else {
      greeting = "Good Evening";
      setGreatingIcon(moon);
    }

    setGreating(greeting);
  });

  return (
    <div className="greating-card p-3">
      <div
        className="center"
        style={{
          fontSize: "small",
          color: "white",
          display: "flex",
          alignItems: "center",
        }}
      >
        <b>{greating}</b>
        <Avatar
          src={greatingIcon}
          className="m-1"
          sx={{ width: 26, height: 26 }}
        >
          s
        </Avatar>
      </div>
      <div
        className="mx-4"
        style={{ display: "flex", justifyContent: "flex-start" }}
      >
        <Chip
          avatar={<Avatar sx={{ bgcolor: "#daab2a" }}>N</Avatar>}
          label={
            <div className="m-2" style={{ color: "white", fontWeight: 900 }}>
              ADMIN
            </div>
          }
          variant="outlined"
        />
      </div>
    </div>
  );
};

export default SideNavBar;
